import React, { useState } from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ActiveVoters from "../components/VotersCount/ActiveVoters";
import TotalVoters from "../components/VotersCount/TotalVoters";
import InActiveVoters from "../components/VotersCount/InActiveVoters";

const UtahVotersCount = () => {
  const [activeTab, setActiveTab] = useState("Total Voters");

  const handleTabSelect = (tabKey) => {
    setActiveTab(tabKey);
  };

  return (
    <>
      <div>
        <LandingSection
          data={{ imageName: "voterscount.webp", title: "Utah Voters Count", visible:"" }}
        />
        <div className="verticals_section">
          <div className="verticals-intro">
            <div className="verticals-intro-sec1">
              <h2>
                Utah Voter Participation Trends A Look at Voter Engagement
                Across the State
              </h2>
            </div>
            <div className="verticals-intro-sec2">
              <p>
                Utah has witnessed a steady increase in voter participation over
                the past decade, reflecting growing civic engagement among its
                residents. From presidential elections to local school board
                races, more Utahns are registering to vote and showing up at the
                polls.
              </p>
              {/* <ActionButton data="Explore More" /> */}
            </div>
          </div>
        </div>
        <div className="tabtitle">
          <p>
            Each of the following tabs will display its own set of insights:
          </p>
        </div>
        <div className="w-[90vw] h-auto rounded-lg  justify-center items-center mx-auto">
          <Tabs
            id="controlled-tab-example"
            className="tabs"
            activeKey={activeTab}
            onSelect={handleTabSelect}
          >
            {/* Total Voters */}
            <Tab eventKey="Total Voters" title="Total Voters" id="Total Voters">
              <main className="max-w-8xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
                <div className="bg-white rounded-xl border border-blue-800 shadow-[0_8px_24px_rgba(37,99,235,0.6)] hover:shadow-[0_12px_32px_rgba(30,64,175,0.8)] transition-shadow duration-300 p-6 mb-8">
                  <TotalVoters />
                </div>
              </main>
            </Tab>
            {/* Active Voters */}
            <Tab
              eventKey="Active Voters"
              title="Active Voters"
              id="Active Voters"
            >
              <main className="max-w-8xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
                <div className="bg-white rounded-xl border border-blue-800 shadow-[0_8px_24px_rgba(37,99,235,0.6)] hover:shadow-[0_12px_32px_rgba(30,64,175,0.8)] transition-shadow duration-300 p-6 mb-8">
                  <ActiveVoters />
                </div>
              </main>
            </Tab>
            {/* Inactive Voters */}
            <Tab
              eventKey="Inactive Voters"
              title="Inactive Voters"
              id="Inactive Voters"
            >
              <main className="max-w-8xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
                <div className="bg-white rounded-xl border border-blue-800 shadow-[0_8px_24px_rgba(37,99,235,0.6)] hover:shadow-[0_12px_32px_rgba(30,64,175,0.8)] transition-shadow duration-300 p-6 mb-8">
                  <InActiveVoters />
                </div>
              </main>
            </Tab>
          </Tabs>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default UtahVotersCount;
